import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import ProjectTable from "../components/Project/Projects";
// import { Amplify, Auth } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
// import awsconfig from '../aws-exports';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Projects = () => {

  const [selectdProject, setselectdProject] = useState(null)
  const [errorMessage, setErrorMessage] = useState('');
  const [navLink, setNavLink] = useState('');

  const handleProjectChange = (entity) => {
    console.log('PP selected ' + entity.project_id)
    setselectdProject(entity.project_id)
    console.log('p ' + selectdProject)
    setNavLink("/files?projectid=" + entity.project_id)
    setErrorMessage('')
  };
  const validate = () => {
    if (selectdProject == null)
      setErrorMessage("Please select a project folder");
  };
  return (
    <Container style={{  "max-width": "1300px"}}>
      <ProjectTable OnProjectChange={handleProjectChange} />
      <Row>
        <Col className="text-align-end">
          <NavLink to={navLink}>
            <Button variant="primary" onClick={validate}>Select Project Folder</Button>{' '}
          </NavLink>
        </Col>
      </Row>
      <Row>
        <Col>
            <Button variant="primary" onClick={() => window.print()}>Print</Button>
          {errorMessage && (
            <Alert key="danger" variant="danger">
              {errorMessage}
            </Alert>
          )}
        </Col>
      </Row>
    </Container>
  );
};
export default Projects;